const DOORS = [
  {
    key: 'schedule',
    title: '100歳体操 当番表',
    desc: '毎週木曜の担当職員を、月ごとに調整します',
    screen: 'hocchoken-schedule',
  },
  {
    key: 'cases',
    title: '相談記録',
    desc: '相談案件ごとに経過を書き足し、まとまったらWordで出力します',
    screen: 'hocchoken-cases',
  },
];

/** ほおっちょけん（地域相談窓口）用の入り口。2つの業務ツールへ振り分ける。 */
export default function HocchokenHubScreen({ onNavigate, onBack }) {
  return (
    <div className="workspace">
      <div className="workspace-head reveal r1">
        <button className="back-link" type="button" onClick={onBack}>← ホームへ戻る</button>
        <h1 className="workspace-title">ほおっちょけん</h1>
      </div>

      <div className="doors reveal r2">
        {DOORS.map((door) => (
          <button
            key={door.key}
            type="button"
            className="door"
            onClick={() => onNavigate(door.screen)}
          >
            <span className="door-title-wrap">
              <span className="door-title">{door.title}</span>
            </span>
            <span className="door-desc">{door.desc}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
